import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Star } from "lucide-react";

export function Distribution({ dist, total }) {
  return (
    <div className="card-surface p-5 space-y-2" data-testid="rating-distribution">
      <p className="eyebrow">Distribuição das notas</p>
      {[5, 4, 3, 2, 1].map((n) => {
        const v = dist[String(n)] || 0;
        const pct = total ? Math.round((v / total) * 100) : 0;
        return (
          <div key={n} className="flex items-center gap-3 text-sm">
            <span className="flex w-10 items-center gap-1 font-mono">{n}<Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" /></span>
            <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-muted"><div className="h-full rounded-full bg-amber-400 transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
            <span className="w-16 text-right font-mono text-xs text-muted-foreground" data-testid={`rating-dist-${n}`}>{v} · {pct}%</span>
          </div>
        );
      })}
    </div>
  );
}

const tick = { fontSize: 11, fill: "hsl(var(--muted-foreground))" };

export function DailyChart({ series }) {
  if (!series.length) return null;
  return (
    <div className="card-surface p-5" data-testid="rating-daily-chart">
      <p className="eyebrow mb-3">Nota média por dia</p>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={series}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
            <XAxis dataKey="label" tick={tick} tickLine={false} axisLine={false} interval="preserveStartEnd" />
            <YAxis domain={[0, 5]} ticks={[0, 1, 2, 3, 4, 5]} tick={tick} tickLine={false} axisLine={false} width={28} />
            <Tooltip formatter={(v, _n, p) => [v == null ? "sem avaliações" : `${v} (${p.payload.count} avaliações)`, "Média"]} />
            <Bar dataKey="avg" fill="#fbbf24" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
